import { MultifactorCodeFormValues } from '..'
import { MultifactorAuthenticationCodeMutationVariables } from './mutation'

export const toMutationVariables = (
  inputValues: MultifactorCodeFormValues
): MultifactorAuthenticationCodeMutationVariables => {
  return { input: { code: inputValues.code, rememberMe: inputValues.rememberMe } }
}
